/* =============================================================================
 * FOZOCO • Cart Skin
 * -----------------------------------------------------------------------------
 * Ajustes visuais dentro do drawer do Section Store (<section-store--cart-block>).
 *
 * Por que precisa de JS para aplicar CSS:
 *   O drawer renderiza dentro de um shadow root. CSS do documento (theme.css,
 *   fozoco-custom.css, tag <style> no theme.liquid) NAO atravessa essa fronteira,
 *   entao a unica forma de estilizar por fora do app e injetar um <style> dentro
 *   do proprio shadow root — que e `open`, portanto acessivel.
 *
 * Por que nao usar o campo "Custom CSS" do app:
 *   Ele existe (general.custom_css / custom_css_enabled) e seria o lugar certo,
 *   mas nao esta aceitando o valor nesta conta: continua `false` / "" mesmo apos
 *   salvar, enquanto outros campos da mesma tela salvam normalmente. Se um dia
 *   passar a funcionar, mova as regras para la e apague este arquivo.
 *
 * Regra atual — barra do timer:
 *   O titulo "ENVIO NACIONAL 🇧🇷 | PEDIDO RESERVADO POR {{timer}}" quebrava em
 *   duas linhas no mobile. No desktop o drawer tem 440px fixos e o texto mede
 *   ~398px em 15px bold, ou seja, ja cabe; quem quebra e o mobile, onde o drawer
 *   ocupa a largura toda da tela. Por isso o clamp() em vez de um tamanho fixo:
 *   mantem 15px no desktop e so reduz quando a tela e estreita.
 *   O `nowrap` e o que garante que nunca quebra; o clamp e o que evita que, sem
 *   poder quebrar, o texto vaze para fora da barra.
 *
 *   Medido no tema AUG30 (altura da barra: ~40px = 1 linha, ~61px = 2 linhas):
 *     320px  -> 34px  (fonte 10.2px)
 *     375px  -> 36px  (fonte 12px)    [antes: 61px]
 *     1280px -> 40px  (fonte 15px, igual ao original, so que bold)
 * ========================================================================== */

(function () {
  "use strict";

  if (window.__FOZOCO_CART_SKIN__) return;
  window.__FOZOCO_CART_SKIN__ = true;

  var HOST_TAG = "section-store--cart-block";
  var STYLE_ID = "fozoco-cart-skin";

  var CSS = [
    "/* injetado por assets/fozoco-cart-skin.js */",
    "",
    ".cart-timer {",
    "  font-weight: 700;",
    "  white-space: nowrap;",
    "  font-size: clamp(10px, 3.2vw, 15px);",
    "}",
    "",
    "/* Buraco entre o nome e o preco nos cards de upsell.",
    "   O app sempre renderiza <span class=\"...product-subtitle\"> mesmo quando o",
    "   produto nao tem subtitulo, e o span vazio ainda ocupa 16px de altura:",
    "     titulo 17 + gap 4 + subtitulo VAZIO 16 + gap 4 + preco 16 = 57px",
    "   Escondendo so quando esta :empty, a coluna cai para 37px e o subtitulo",
    "   continua aparecendo normalmente nos produtos que tiverem um. */",
    ".cart-products-upsell-product-subtitle:empty {",
    "  display: none;",
    "}"
  ].join("\n");

  function apply(host) {
    try {
      var root = host && host.shadowRoot;
      if (!root) return false;
      if (root.querySelector("#" + STYLE_ID)) return true;

      var style = document.createElement("style");
      style.id = STYLE_ID;
      style.textContent = CSS;
      root.appendChild(style);
      return true;
    } catch (_) {
      return false;
    }
  }

  /* O app recria o conteudo do drawer a cada atualizacao do carrinho. O <style>
   * fica como filho direto do shadow root (irmao do container que e recriado),
   * mas se algum re-render limpar tudo, este observer o repoe. */
  function watch(host) {
    try {
      var observer = new MutationObserver(function () { apply(host); });
      observer.observe(host.shadowRoot, { childList: true });
    } catch (_) {}
  }

  /* O custom element e definido pelo script do app, que carrega depois deste.
   * Tenta por ~30s e desiste em silencio se o drawer nao existir nesta pagina. */
  var attempts = 0;
  (function attach() {
    var host = document.querySelector(HOST_TAG);

    if (host && host.shadowRoot) {
      apply(host);
      watch(host);
      return;
    }

    if (++attempts > 60) return;
    setTimeout(attach, 500);
  })();
})();
